import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "vue-deksoft" }
const _hoisted_2 = { class: "vue-deksoft__title" }
const _hoisted_3 = { class: "vue-deksoft__image" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "vue-deksoft__content" }
const _hoisted_6 = { class: "vue-deksoft__content-left" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "Obvyklé použití", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Charakteristika", -1)
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "vue-deksoft__content-right" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, "Specifikace", -1)
const _hoisted_12 = ["href"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "vue-deksoft__buttons" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compositions, (composition, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "vue-deksoft__item"
      }, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(composition.name), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: composition.image,
            width: "300"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(composition.usage, (place, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(place), 1))
              }), 128))
            ]),
            _hoisted_8,
            _createElementVNode("div", {
              innerHTML: composition.characteristic
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(composition.specifications, (specification, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  (specification.url)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: specification.url,
                        target: "_blank"
                      }, _toDisplayString(specification.name), 9, _hoisted_12))
                    : _createCommentVNode("", true),
                  (!specification.url)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(specification.name), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          (composition.pdf)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: composition.pdf,
                role: "button",
                target: "_blank",
                class: "dek-button-green"
              }, "PDF", 8, _hoisted_15))
            : _createCommentVNode("", true),
          (composition.video)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: composition.video,
                role: "button",
                class: "dek-button-green"
              }, "Video", 8, _hoisted_16))
            : _createCommentVNode("", true),
          (composition.catalogue)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: composition.catalogue,
                role: "button",
                class: "dek-button-green"
              }, "Katalogový list", 8, _hoisted_17))
            : _createCommentVNode("", true),
          (composition.details)
            ? (_openBlock(), _createElementBlock("a", {
                key: 3,
                href: composition.details,
                role: "button",
                class: "dek-button-green"
              }, "Detaily", 8, _hoisted_18))
            : _createCommentVNode("", true),
          (composition.thermal)
            ? (_openBlock(), _createElementBlock("a", {
                key: 4,
                href: composition.thermal,
                role: "button",
                class: "dek-button-green"
              }, "Tepelná technika", 8, _hoisted_19))
            : _createCommentVNode("", true),
          (composition.configurator)
            ? (_openBlock(), _createElementBlock("a", {
                key: 5,
                href: composition.configurator,
                role: "button",
                class: "dek-button-green"
              }, "Kalkulace", 8, _hoisted_20))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}